import 'css-chunksrc/client/pages/projectPortfoliosPage/projectPortfolios/projectPortfolio/styles.scss';export default {
  "portfolioInfo": "_portfolioInfo_9397c_1",
  "scrollingText": "_scrollingText_9397c_11",
  "row": "_row_9397c_15",
  "portfolioIcon": "_portfolioIcon_9397c_25",
  "iconBox": "_iconBox_9397c_31",
  "name": "_name_9397c_39",
  "contextualMenu": "_contextualMenu_9397c_46",
  "dark": "_dark_9397c_50",
  "menuIcon": "_menuIcon_9397c_60",
  "removeIcon": "_removeIcon_9397c_64",
  "positive": "_positive_9397c_68",
  "warning": "_warning_9397c_72"
};